import { useState, useEffect } from 'react';
import axios from 'axios';
import { AppointmentCard } from './AppointmentCard';
import { apptT } from './apptI18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const ClientNextAppointment = ({ lang }) => {
  const [appt, setAppt] = useState(null);
  const [error, setError] = useState('');
  const t = apptT[lang] || apptT.it;

  useEffect(() => {
    axios.get(`${API}/client/next-appointment`, auth()).then((r) => setAppt(r.data.appointment)).catch(() => {});
  }, []);

  if (!appt) return null;
  const respond = async (action, note) => {
    setError('');
    try {
      setAppt((await axios.post(`${API}/client/appointments/${appt.pratica_id}/respond`, { action, note }, auth())).data);
    } catch (e) {
      setError(t.error);
      throw e;
    }
  };
  return (
    <div className="bg-white border-l-4 border-[#C9A227] shadow-sm p-6 mb-8" data-testid="client-next-appointment">
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#C9A227] mb-1">{t.title}</p>
      <p className="text-sm text-slate-500 mb-3">{appt.titolo} · {appt.numero_pratica}</p>
      <AppointmentCard appt={appt} lang={lang} onRespond={respond} error={error} />
    </div>
  );
};
